import React, { useEffect, useState } from 'react';
import api from '../../lib/api';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import { toast } from 'sonner';

export default function AdminVcards() {
  const [data, setData] = useState([]);
  const load = () => api.get('/admin/vcards').then(r => setData(r.data.vcards || [])).catch(() => {});
  useEffect(() => { load(); }, []);
  const update = async (id, payload, message) => {
    try {
      await api.patch(`/admin/vcards/${id}`, payload);
      toast.success(message);
      await load();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to update vCard');
    }
  };
  const remove = async (id) => {
    try {
      await api.delete(`/admin/vcards/${id}`);
      toast.success('vCard disabled');
      await load();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to disable vCard');
    }
  };
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-slate-900 tracking-tight" style={{ fontFamily: 'Outfit' }}>vCard Management</h1>
        <p className="text-slate-500 text-sm mt-0.5">View public smart-link pages created by users.</p>
      </div>
      <Card className="bg-white border border-slate-200 shadow-sm rounded-2xl">
        <CardHeader><CardTitle className="text-lg" style={{ fontFamily: 'Outfit' }}>vCards</CardTitle></CardHeader>
        <CardContent className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Name</TableHead>
                <TableHead>Username</TableHead>
                <TableHead>Owner</TableHead>
                <TableHead>Package</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Created</TableHead>
                <TableHead />
              </TableRow>
            </TableHeader>
            <TableBody>
              {data.map(v => (
                <TableRow key={v.id}>
                  <TableCell>{v.display_name || v.full_name}</TableCell>
                  <TableCell className="font-mono text-xs">{v.username}</TableCell>
                  <TableCell>{v.owner_name || v.user_id || '-'}</TableCell>
                  <TableCell>{v.package?.name || '-'}</TableCell>
                  <TableCell>{v.status}</TableCell>
                  <TableCell>{v.created_at ? new Date(v.created_at).toLocaleDateString() : '-'}</TableCell>
                  <TableCell className="flex gap-2">
                    <Button type="button" variant="outline" size="sm" onClick={() => update(v.id, { status: v.status === 'active' ? 'disabled' : 'active' }, v.status === 'active' ? 'vCard disabled' : 'vCard enabled')}>
                      {v.status === 'active' ? 'Disable' : 'Enable'}
                    </Button>
                    <Button type="button" variant="outline" size="sm" onClick={() => remove(v.id)}>Delete</Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
